module.exports = __webpack_public_path__ + "static/media/okai.e097b418.png";